module.exports = __webpack_public_path__ + "img/biaoqian_zongheti.ae45be33.png";